module.exports = __webpack_public_path__ + "img/goodcasper-1200x630.c929064f.png";